import { supabase } from '../../../../services/supabase';

export const getSlackConnectionStatus = async (
  userId: string,
): Promise<boolean> => {
  const { data, error } = await supabase
    .from('users')
    .select('slack_user_id')
    .eq('id', userId)
    .single();

  if (error) throw new Error('Error fetching Slack connection status');

  return !!data?.slack_user_id;
};

export const disconnectSlack = async (userId: string): Promise<boolean> => {
  const { error } = await supabase
    .from('users')
    .update({ slack_user_id: null })
    .eq('id', userId);

  return !error;
};

export const updateSlackID = async (
  userId: string,
  slackID: string,
): Promise<boolean> => {
  const { error } = await supabase
    .from('users')
    .update({ slack_user_id: slackID })
    .eq('id', userId);
  return !error;
};
